(function ($) {

    //Two liders, same level. Research Group page
    if ($('.research-group__field-resgr-main-researchers > .field__item').length > 1) {
      if ($('.research-group__field-resgr-main-researchers > .field__item').length % 2 == 0) {
        $('.main_research').addClass('two_main');
      } else {
        $('.main_research').addClass('three_main');
        // $('.main_research .researcher .col-12').removeClass('col-lg-7 col-xl-7 col-lg-5 col-xl-5').addClass('col-lg-12');
      }
      $('.main_research > .container > .layout > .col-12').removeClass('col-lg-8 col-xl-8');
      $('.main_research > .container > .layout > .col-lg-4').remove();
      $('.research-group__field-resgr-main-researchers').addClass('row');
    }

    if (window.location.hash != "#eulalia-de" && window.location.hash != "#francesc-posas") {
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }

})(jQuery, Drupal);